import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AsmPayload } from '../../../domain/asm.domain';
import { DialogData } from '../../../domain/common.model';
import { DialogAction } from '../store/dialog.action';
import { UserState } from '../store/user.state';
import { GenericService } from './generic.service';

@Injectable()
export class AsmService extends GenericService {
    private passwordKeys = ['oldPassword', 'password', 'password2'];

    constructor(
        private store: Store,
        private http: HttpClient,
        private translateService: TranslateService
    ) {
        super(store);
    }

    logAsmPayload(req: HttpRequest<any>, supportId: string): void {
        const headers = {};
        req.headers.keys().forEach(key => headers[key] = req.headers.get(key));
        const user = this.store.selectSnapshot(UserState.getUser);
        const payload = new AsmPayload({
            userId: user?.id || null,
            supportId,
            url: req.url,
            method: req.method,
            headers,
            body: this.cleanBodyPasswordData({...req.body})
        });

        this.http.post(`/api/public/asm`, payload)
            .pipe(catchError(this.errorsMain))
            .subscribe();
        this.showAsmModal(supportId);
    }

    private cleanBodyPasswordData(body: {}): string {
        this.passwordKeys.forEach(key => {
            if (key in body) {
                body[key] = '*';
            }
        });
        return JSON.stringify(body);
    }

    private showAsmModal(supportId: string): Observable<any> {
        const data = new DialogData();
        data.titleLabel = 'MODAL.ASM_TITLE';
        data.descriptionHtml = this.translateService.instant('MODAL.ASM_MESSAGE', {supportId});
        data.hasCancelLabel = false;
        data.confirmLabel = 'BUTTON.OK';
        return this.store.dispatch(new DialogAction.OpenGeneric(data));
    }
}
